module.exports = __webpack_public_path__ + "img/logo_ooh.d4b32659.png";